<template>
  <div>
    <v-app-bar
      app
      elevate-on-scroll
      class="hidden-md-and-down"
      color="#FFFFFF"
      height="110px"
    >
      <v-layout wrap justify-center hidden-xs-only fill-height>
        <v-flex xs12 pb-2 align-self-start>
          <AppHeader0 />
        </v-flex>
        <v-flex xs12 sm11 align-self-center>
          <v-layout wrap justify-center pb-5>
            <v-flex sm2 md2 lg2 align-self-center>
              <v-layout wrap justify-end>
                <v-flex xs6 md8 lg9 align-self-center>
                  <router-link to="/">
                    <v-img
                      src="./../../assets/logoKerala.png"
                      height="50px"
                      contain
                    />
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer></v-spacer>
            <!-- <v-flex xs12 sm5 md3 lg3 text-right align-self-center>
          <v-text-field
            placeholder="Search Product"
            filled
            rounded
            dense
            height="30px"
            :hide-details="true"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-flex> -->
            <v-flex xs6 sm5 md5 lg5 align-self-center>
              <v-layout wrap justify-end>
                <v-flex pt-2 text-left>
                  <AccountMenu />
                </v-flex>
                <v-flex pt-2 text-right>
                  <v-layout wrap justify-end>
                    <v-flex xs12 pl-5 text-right>
                      <v-btn block text rounded :ripple="false" to="/wishlist">
                        <v-badge
                          color="#1D9A50"
                          right
                          small
                          :content="appWishlist ? appWishlist : '0'"
                          overlap
                          offset-y="8"
                        >
                          <v-icon color="black">mdi-heart</v-icon>
                        </v-badge>
                        &nbsp;
                        <span
                          style="
                            color: #000;
                            font-family: opensanssemibold;
                            text-transform: capitalize;
                          "
                          >Wishlist</span
                        >
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex pt-2 text-right>
                  <v-layout wrap>
                    <v-flex xs9 text-right>
                      <v-btn block text rounded :ripple="false" to="/cart">
                        <v-badge
                          color="#1D9A50"
                          right
                          small
                          :content="appCart ? appCart : '0'"
                          overlap
                          offset-y="7"
                        >
                          <v-icon color="black">mdi-cart</v-icon>
                        </v-badge>
                        &nbsp;
                        <span
                          style="
                            color: #000;
                            font-family: opensanssemibold;
                            text-transform: capitalize;
                          "
                          >Cart</span
                        >
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>
    <v-app-bar
      app
      dark
      color="#ffffff"
      dense
      flat
      height="110px"
      class="hidden-lg-and-up"
    >
      <v-layout wrap justify-center fill-height>
        <v-flex xs12 pb-2 align-self-start>
          <AppHeader0 />
        </v-flex>
        <v-flex xs12 pb-10 pb-xs-10 pb-sm-0 pb-md-0 pb-lg-0 pb-xl-0>
          <v-layout wrap>
            <v-app-bar-nav-icon @click.native="sideNav = !sideNav">
              <v-icon class="pl-3" color="#30B868">mdi-menu</v-icon>
            </v-app-bar-nav-icon>
            <v-layout wrap justify-center>
              <!-- <v-flex xs6 sm5>
            <v-layout wrap>
            <v-flex text-left pt-2>
              <v-img
                src="./../../assets/icons/greenphone.png"
                height="25px"
                contain
              />
            </v-flex>
            <v-flex
             text-left
            >
              <span
                style="
                  font-family: RobotoRegular;
                  color: black;
                  font-size: 13px;
                "
                >Call Us</span
              >
              <br />
              <span
                style="
                  font-family: RobotoRegular;
                  color: black;
                  font-size: 13px;
                "
                >+91 8396568429</span
              >
            </v-flex>
          </v-layout>
          </v-flex> -->
              <v-flex xs3 sm6 md7 text-center>
                <router-link to="/">
                  <v-img
                    contain
                    height="50px"
                    src="./../../assets/greenlogo.png"
                  ></v-img>
                </router-link>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>
    <v-navigation-drawer
      v-model="sideNav"
      fixed
      temporary
      class="hidden-lg-and-up"
      color="#003D29"
      right
    >
      <v-layout wrap justify-center>
        <v-flex
          xs12
          v-for="(item, i) in navItems"
          :key="i"
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
          link
        >
          <router-link :to="item.route">
            <v-layout wrap justify-center>
              <v-flex xs12>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 15px;
                    color: #ffffff;
                    letter-spacing: 2px;
                  "
                  >{{ item.name }}</span
                >
              </v-flex>
              <v-flex xs12 pt-2>
                <v-divider color="#fff"></v-divider>
              </v-flex>
            </v-layout>
          </router-link>
        </v-flex>
        <v-flex xs12 pa-2 text-center pl-4 v-if="appLogin">
          <v-btn color="#003D29" text to="/profile">
            <span style="color: white; font-family: poppinsregular">PROFILE</span>
          </v-btn>
          <v-divider color="#fff"></v-divider>

          </v-flex>
        <v-flex xs12 pa-2 text-center pl-4 v-if="!appLogin">
          <v-btn color="#003D29" text to="/loginForm">
            <span style="color: white; font-family: poppinsregular">LOGIN</span>
          </v-btn>
          <v-divider color="#fff"></v-divider>

          <v-btn color="#003D29" text to="/signUpForm">
            <span style="color: white; font-family: poppinsregular"
              >SIGNUP</span
            >
          </v-btn>
        </v-flex>

        <v-flex xs6 pa-2 text-center pl-4 v-if="appLogin">
          <v-layout wrap justify-end>
            <v-btn color="#003D29" text @click="appLogout">
              <span style="color: white; font-family: poppinsregular"
                >Logout</span
              >
            </v-btn>
          </v-layout>
        </v-flex>
        <!-- <v-flex>
          <router-link to="/Login">
            <span
              style="
                font-family: poppinslight;
                font-size: 15px;
                color: #ffffff;
                letter-spacing: 2px;
              "
              >LOGIN</span
            >
          </router-link>
        </v-flex>
        <v-flex xs12 pt-2>
          <v-divider color="#fff"></v-divider>
        </v-flex>
        <v-flex>
          <router-link to="/singUp">
            <span
              style="
                font-family: poppinslight;
                font-size: 15px;
                color: #ffffff;
                letter-spacing: 2px;
              "
              >SIGNUP</span
            >
          </router-link>
        </v-flex> -->
      </v-layout>
    </v-navigation-drawer>
  </div>
</template>
  <script>
//   import Notification from "./notification";
import AccountMenu from "./accountMenu";
import AppHeader0 from "./AppHeader0";
export default {
  components: {
    //   Notification,
    AccountMenu,
    AppHeader0,
  },
  data() {
    return {
      navDrawer: false,
      transAppBar: true,
      searchKey: null,
      sideNav: false,
      // notification: {},
      items: [
        { name: "HOME", route: "/", type: "link" },
        { name: "ABOUT US ", route: "/about", type: "link" },
        { name: "ECO SHOP", route: "/ecoShopList", type: "link" },
        // { name: "ROOM TARIF", route: "/accommadation", type: "link" },
        { name: "BLOG ", route: "/blogList", type: "link" },
        { name: "CONTACT US", route: "/ContactUs", type: "link" },
      ],
      navItems: [
        { name: "HOME", route: "/", type: "link" },
        { name: "ABOUT US ", route: "/about", type: "link" },
        // { name: "ECO SHOP", route: "/ecoShop", type: "link" },
        // { name: "BLOG ", route: "/blogList", type: "link" },
        // { name: "CONTACT US", route: "/ContactUs", type: "link" },
        //{ name: "login", route: "/loginForm", type: "link" },
        //{ name: "Signup", route: "/signUpForm", type: "link" },
        // { name: "profile", route: "/profile", type: "link" },
        // { name: "ROOM TARIF", route: "/accommadation", type: "link" },
        { name: "wishlist ", route: "/wishlist", type: "link" },
        { name: "Cart", route: "/cart", type: "link" },
      ],
    };
  },

  computed: {
    appUser() {
      return this.$store.state.userData;
    },
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appType() {
      return this.$store.state.userType;
    },
    appCartType() {
      return this.$store.state.cartType;
    },
    appCart() {
      if (this.$store.state.cartCount == undefined) {
        return 0;
      } else {
        return this.$store.state.cartCount;
      }
    },
    appWishlist() {
      if (this.$store.state.wishListCount == undefined) {
        return 0;
      } else {
        return this.$store.state.wishListCount;
      }
    },
  },
  // beforeMount() {
  //   this.searchKey = this.$route.query.searchKey;
  // },
  methods: {
    //   appSearch() {
    //     if (this.$route.query.searchKey == this.searchKey) return;
    //     this.$router.push({
    //       path: "/PlanYourVisit",
    //       query: {
    //         searchKey: this.searchKey,
    //       },
    //     });
    //   },

    appLogout() {
      this.$store.commit("logoutUser", true);
    },

    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;

      if (top > 2) {
        this.transAppBar = false;
      } else {
        this.transAppBar = true;
      }
    },
  },
};
</script>
  <style scoped>
.v-toolbar__content {
  padding: 0px !important;
}
.custom .v-select__slot {
  font-family: opensansregular; /* Replace with your preferred font-family */
  font-size: 14px; /* Replace with your preferred font-size */
}
</style>